// extracted by mini-css-extract-plugin
var _1 = "ExpandedPostModalAnnotation-module__container--rAA12";
export { _1 as "container" }
